(async function () {
  const codeGetBtns = document.querySelectorAll('.code_get_btn');
  if (codeGetBtns.length === 0) return;
  for (const codeGetBtn of codeGetBtns) {
    codeGetBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      // data-coupon-id属性があるかチェック（カートページ用）
      const couponId = codeGetBtn.getAttribute('data-coupon-id');
      
      if (couponId) {
        // カートページ：特定のクーポンIDに対応するモーダルのみ表示
        const targetModals = document.querySelectorAll(`[data-coupon-id="${couponId}"] .js-coupon-view`);
        targetModals.forEach((targetModal) => {
          targetModal.style.display = 'flex';
        });
      } else {
        // 商品詳細ページ：従来通りすべてのモーダルを表示
        const elements = document.querySelectorAll('.js-coupon-view');
        elements.forEach((element) => {
          element.style.display = 'flex';
        });
      }
    });
  }
  
  const couponButtons = document.querySelectorAll('.coupon-modal__content__buttons__get-coupon-code');
  if (couponButtons.length === 0) return;
  for (const button of couponButtons) {
    button.addEventListener('click', async function () {
      const discountCode = this.dataset.discountCode;
      const mainContent = this.closest('.coupon-modal__content').querySelector('.coupon-modal__content__main');
      this.disabled = true;
      try {
        const response = await fetch(`/discount/${discountCode}`);
        if (response.ok) {
          this.textContent = 'クーポンを取得しました！';
          this.style.backgroundColor = '#D9D9D9';
          mainContent.textContent = `取得済${discountCode}`;
          mainContent.style.color = '#492815';
        } else {
          mainContent.textContent = 'エラーが発生しました。ページを更新してください。';
        }
      } catch (error) {
        this.disabled = false;
        mainContent.textContent = 'エラーが発生しました。もう一度お試しください。';
      }
    });
  }
  
  const closeButtons = document.querySelectorAll('.js-coupon-close');
  for (const button of closeButtons) {
    button.addEventListener('click', function (e) {
      const couponViews = document.querySelectorAll('.js-coupon-view');
      couponViews.forEach((couponView) => {
        couponView.style.display = 'none';
      });
    });
  }
})();
